import { render, staticRenderFns } from "./indexSocialModel.vue?vue&type=template&id=f1e0faaa&scoped=true"
import script from "./indexSocialModel.vue?vue&type=script&lang=js"
export * from "./indexSocialModel.vue?vue&type=script&lang=js"
import style0 from "./indexSocialModel.vue?vue&type=style&index=0&id=f1e0faaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e0faaa",
  null
  
)

export default component.exports